export var ACTION;
(function (ACTION) {
    ACTION["EDIT_MOBILE_NUMBER"] = "EDIT_MOBILE_NUMBER";
    ACTION["PHONE_NUMBER_ONCHANGE"] = "PHONE_NUMBER_ONCHANGE";
    ACTION["DISABLE_CONTINUE"] = "DISABLE_CONTINUE";
    ACTION["ENABLE_CONTINUE"] = "ENABLE_CONTINUE";
    ACTION["GO_BACK"] = "GO_BACK";
})(ACTION || (ACTION = {}));
